var React = require('react');

function Laptop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#2185D0","strokeWidth":"10","key":1},[React.createElement("path",{"strokeLinecap":"round","d":"M90 156h96","key":0}),React.createElement("path",{"d":"M44 119h185l27 36a14 14 0 01-11 22H28a14 14 0 01-11-22l27-36h0zM61 5h153c8 0 14 6 14 14v100h0H47V19c0-8 6-14 14-14z","key":1})])]);
}

Laptop.defaultProps = {"viewBox":"0 0 273 182"};

module.exports = Laptop;

Laptop.default = Laptop;
